import * as actionTypes from '../constants/actionTypes';

const initialState = {
  salesforceSquads: undefined,
  salesforceMembers: undefined,
  userIsLeader: undefined,
  userIsAdmin: undefined
};
const peopleStructureReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SALESFORCE_SQUADS:
      return {
        ...state,
        salesforceSquads: action.squads,
        salesforceSquadsNames: action.squadsNames
      };
    case actionTypes.SET_SALESFORCE_MEMBERS:
      return {
        ...state,
        salesforceMembers: action.salesforceMembers
      };
    case actionTypes.SET_USER_IS_LEADER:
      return {
        ...state,
        userIsLeader: action.userIsLeader
      };
    case actionTypes.SET_USER_IS_ADMIN:
      return {
        ...state,
        userIsAdmin: action.userIsAdmin
      };
    case actionTypes.SET_LEADERSHIP_SQUAD:
      return {
        ...state,
        leadershipSquad: action.leadershipSquad
      };
    case actionTypes.SET_ALL_USERS:
      return {
        ...state,
        allUsers: action.allUsers
      };
    case actionTypes.SET_ALL_PROFILES:
      return {
        ...state,
        allProfiles: action.allProfiles
      };
    case actionTypes.SET_ALL_ROLES:
      return {
        ...state,
        allRoles: action.allRoles
      };
    case actionTypes.SET_ALL_CHANNELS:
      return {
        ...state,
        allChannels: action.allChannels
      };
    default:
      return state;
  }
};

export default peopleStructureReducer;
